import ErrorHandler from "./ErrorHandler"
import { api } from "services/api"
import { mapProductToFormData } from "./mappers/mapProdutToFormData"

class ApiProducts extends ErrorHandler {
  async getAll() {
    try {
      const axiosResponse = await api.get("/products")

      return {
        products: axiosResponse.data,
        status: axiosResponse.status
      }
    } catch (e) {
      return {
        products: [],
        status: this.errorHandler(e)
      }
    }
  }

  async create(product: App.Product) {
    try {
      const axiosResponse = await api.post("/product", product)

      return {
        status: axiosResponse.status,
        response: axiosResponse
      }
    } catch (e) {
      return this.errorHandler(e)
    }
  }

  async updateByPrefixUrl(product: App.Product, previousPrefixUrl: string) {
    try {
      const axiosResponse = await api.patch(`/product/${previousPrefixUrl}`, product)

      return {
        status: axiosResponse.status,
        response: axiosResponse
      }
    } catch (e) {
      return this.errorHandler(e)
    }
  }

  async deleteByPrefixUrl(prefixUrl: string) {
    try {
      const axiosResponse = await api.delete(`/product/${prefixUrl}`)

      return {
        status: axiosResponse.status,
        response: axiosResponse
      }
    } catch (e) {
      return this.errorHandler(e)
    }
  }

  async createProductWithFiles(product: App.Product, filesObj: App.ProductFilesObj) {
    const formData = mapProductToFormData(product, filesObj)

    return api.post("/product", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  async updateProductWithFiles(product: App.Product, filesObj: App.ProductFilesObj, id: string) {
    const formData = mapProductToFormData(product, filesObj)

    return api.put(`/product/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  async updateIsPublished(id: string) {
    try {
      const axiosResponse = await api.put(`/product/published/${id}`)

      return {
        status: axiosResponse.status,
        response: axiosResponse
      }
    } catch (e) {
      throw this.errorHandler(e)
    }
  }

  async getProductOptions() {
    try {
      const { data } = await api.get("/products/options")

      return data.data.options
    } catch (error) {
      return []
    }
  }

  async listExternalProducts() {
    return await api.get("/products/external")
  }

  async getProductById(id: string) {
    const { data } = await api.get(`/product/info/${id}`)

    return data.product
  }
}

export default ApiProducts
